module.exports = __webpack_public_path__ + "fonts/895f5b0.ttf";